import { Product } from '@/entities/product.entity';

export function generateInventoryKey(selectedVariants: Record<string, string>): string {
  const sortedKeys = Object.keys(selectedVariants).sort();
  if (sortedKeys.length === 0) {
    return 'default';
  }
  return sortedKeys.map((key) => selectedVariants[key]).join('-');
}

export function isVariantCombinationInStock(
  product: Product,
  selectedVariants: Record<string, string>
): boolean {
  const variantId = selectedVariants['variant'];
  if (!variantId) return false;
  const variant = product.variants?.find((v) => v.id === variantId);
  return variant ? variant.stock > 0 : false;
}

export function getAvailableStock(
  product: Product,
  selectedVariants: Record<string, string>
): number {
  const variantId = selectedVariants['variant'];
  if (!variantId) return 0;
  const variant = product.variants?.find((v) => v.id === variantId);
  return variant?.stock || 0;
}

export function areAllVariantsSelected(
  product: Product,
  selectedVariants: Record<string, string>
): boolean {
  if (!product.variants || product.variants.length === 0) {
    return true;
  }
  return !!selectedVariants['variant'];
}

export function getVariantValues(product: Product, variantLabel: string): string[] {
  const variant = product.variants?.find((v) => v.label === variantLabel);
  if (!variant?.options) return [];
  return Object.values(variant.options);
}

export function isVariantValueAvailable(
  product: Product,
  variantLabel: string,
  variantValue: string,
  currentSelections: Record<string, string>
): boolean {
  const testSelections = {
    ...currentSelections,
    [variantLabel]: variantValue,
  };
  if (!areAllVariantsSelected(product, testSelections)) {
    return true;
  }
  return isVariantCombinationInStock(product, testSelections);
}
